import styled from '@emotion/styled';
import { mainColors } from 'src/assets/colors';
import { fontSize } from 'src/assets/fonts-config';

interface PlatformType {
    platform: string;
    isLegend?: boolean;
}

export const LegendWrapper = styled('div', { label: 'LegendWrapper' })`
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 8px;
`;

export const PlatformName = styled('span', { label: 'PlatformName' })<PlatformType>`
    font-size: ${fontSize.xRegular};
    font-family: var(--fontFamilyPrimary);
    color: ${({ platform }): string => platform === 'ios' ? mainColors.main.secondary : mainColors.status.success };
`;

export const PlatformDot = styled('div', { label: 'PlatformDot' })<PlatformType>`
    background: ${({ platform }): string => platform === 'ios' ? mainColors.main.secondary : mainColors.status.success };
    margin: 0 8px;
    ${({ isLegend }): string => isLegend === true ? 'height: 8px; width: 8px;' : 'height: 12px; width: 12px; margin-left: 0;' };
`;
